import { MYCOLORS } from "./mypallette";
import { createTheme } from "@material-ui/core/styles";

export const dark = createTheme({
  palette: {
    type: "dark",
    primary: {
      main: MYCOLORS.dback,
    },
    secondary: {
      main: MYCOLORS.dhighlight,
    },
    info: {
      main: MYCOLORS.ddeck, //card deck back
    },

    // text: {
    //   primary: MYCOLORS.dtitletext,
    //   secondary: MYCOLORS.lback,
    // },
    background: {
      default: MYCOLORS.dback,
      paper: MYCOLORS.dpaper,
    },
  },

  // typography: {
  //   fontFamily: ["Roboto", "cursive"].join(","),
  //},

  overrides: {
    MuiRadio: {
      root: {
        color: MYCOLORS.dhighlight,
        backgroundColor: "transparent",
      },
      /* colorSecondary: {
          '&$checked': {
            color: 'green',
          },
        }, */
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: MYCOLORS.dback,
        color: MYCOLORS.dhighlight,
        fontSize: 14,
      },
    },
    MuiCssBaseline: {
      "@global": {
        "*::-webkit-scrollbar": {
          width: "16px",
        },

        "*::-webkit-scrollbar-thumb": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.dthumb,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.4)",
        },

        "*::-webkit-scrollbar-thumb:hover": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.dthumbhover,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.8)",
        },

        "*::-webkit-scrollbar-track": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.dback,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.2)",
        },

        "*::-webkit-scrollbar-track:hover": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.dback,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.4)",
        },
      },
    },
    MuiCard: {
      root: {
        //background: `radial-gradient(circle at center, ${MYCOLORS.dhighlight} -100%, ${MYCOLORS.dback} 70%)`,
      },
    },
  },
});

export const light = createTheme({
  //shadows: ["none"],
  palette: {
    type: "light",
    primary: {
      main: MYCOLORS.lback,
    },
    secondary: {
      main: MYCOLORS.lhighlight,
    },
    info: {
      main: MYCOLORS.ldeck, //card deck back
    },
    // text: {
    //   primary: MYCOLORS.ltitletext,
    //   secondary: MYCOLORS.dback,
    // },
    background: {
      default: MYCOLORS.lback,
      paper: MYCOLORS.lpaper,
    },
  },

  // typography: {
  //   fontFamily: ["Roboto", "cursive"].join(","),
  // },

  overrides: {
    MuiRadio: {
      root: {
        color: MYCOLORS.lback, //the unchecked radio to be same color as the card
        backgroundColor: "transparent",
      },
      colorSecondary: {
        "&$checked": {
          color: MYCOLORS.lback,
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: MYCOLORS.lback,
        color: MYCOLORS.lhighlight,
        fontSize: 14,
      },
    },
    MuiCssBaseline: {
      "@global": {
        "*::-webkit-scrollbar": {
          width: "16px",
        },

        "*::-webkit-scrollbar-thumb": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.lthumb,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.2)",
        },

        "*::-webkit-scrollbar-thumb:hover": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.lthumbhover,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.4)",
        },

        "*::-webkit-scrollbar-track": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.lback,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.2)",
        },

        "*::-webkit-scrollbar-track:hover": {
          borderRadius: "6px",
          backgroundColor: MYCOLORS.lback,
          boxShadow: "inset 0 0 6px rgba(0,0,0,.4)",
        },
      },
    },
    MuiCard: {
      root: {
        //background: `radial-gradient(circle at center, ${MYCOLORS.lback} 50%, ${MYCOLORS.lhighlight} 100%)`,
      },
    },
  },
});
